import { NgModule } from '@angular/core'
import { ImportExportCartComponent } from './import-export-cart.component'
import { ConfigModule } from '@spartacus/core'

@NgModule({
  imports: [
    ConfigModule.withConfig({
      cmsComponents: {
        ImportExportCartComponent: {
          component: ImportExportCartComponent
        }
      }
    })
  ],
  providers: [],
  declarations: [ImportExportCartComponent]
})

export class ImportExportCartModule {
}
